import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { format, isAfter } from 'date-fns';
import {LogementService} from '../../services/logement.service';
import {Logement} from '../../models/logement';
import {ToastService} from '../../services/toast.service';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {faCheckCircle, faCircle} from '@fortawesome/free-regular-svg-icons';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../../services/user.service';

@Component({
    selector: 'app-mes-logements',
    templateUrl: './mes-logements.component.html',
    styleUrls: ['./mes-logements.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MesLogementsComponent implements OnInit {

  faPlus = faPlus;
  faCheckCircle = faCheckCircle;
  faCircle = faCircle;

  logementCourant$: Observable<Logement> = null;
  logement$: Observable<Logement[]>;

  constructor(
    public logementService: LogementService,
    private toastService: ToastService,
    private router: Router,
    public modalService: NgbModal,
    public userService: UserService
  ) {
  }

  ngOnInit() {
    this.logementCourant$ = this.logementService.logementCourant;
    this.logement$ = this.logementService.logements;
    this.logementService.load();
  }

  setLogementCourant(logement: Logement) {
    this.logementService.setLogementCourantId(logement.id).then(() => {
      this.toastService.show(`Le logement '${logement.nom}' a été sélectionné`, {classname: 'toast-success'});
      this.router.navigate(['/accueil']);
    });
  }

  goToMesLocataires(logement: Logement) {
    this.logementService.setLogementCourantId(logement.id).then(() => {
      this.toastService.show(`Le logement '${logement.nom}' a été sélectionné`, {classname: 'toast-success'});
      if (logement.locataires.length === 0) {
        this.router.navigate(['/mes-locataires/creer']);
      } else {
        this.router.navigate(['/mes-locataires']);
      }
    });
  }

  delete(logement: Logement) {
    this.logementService.delete(logement.id).then(data => {
      if (logement.id == this.logementService.getLogementCourantId()) {
        this.logementService.clearLogementCourantId().loadAndSetDefaultLogementCourant().then((logementCourantId) => {
          if (!logementCourantId) {
            this.router.navigate(['/mes-logements/creer']);
          }
        });
      } else {
        this.logementService.load();
      }
      this.toastService.show(data.message, {classname: 'toast-' + data.status});
    });
  }

  getLogementSubtitle(logement: Logement) {
    if (logement.appartement && logement.batiment) {
      return `${logement.batiment.nom} - ${logement.batiment.residence.nom} - ${logement.batiment.residence.adresse.codePostal} ${logement.batiment.residence.adresse.nomCommune}`;
    } else {
      if (logement.adresse) {
        return `${logement.adresse.codePostal} ${logement.adresse.nomCommune}`;
      }
    }
    return '';
  }

  getLogementSecondSubtitle(logement: Logement) {
    if (logement.locataires && logement.locataires.length > 0 && this.userService.isProprietaire(logement)) {

      const dateDebutLocation = new Date(logement.locataires[0].dateDebutLocation);
      const dateFinLocation = null !== logement.locataires[0].dateFinLocation ? new Date(logement.locataires[0].dateFinLocation) : null;

      if (null === dateFinLocation || isAfter(dateFinLocation, new Date())) {
        return `Loué le ${format(dateDebutLocation, 'dd/MM/yyyy')} à ${logement.locataires[0].nom} ${logement.locataires[0].prenom}`;
      }

    } else {
      return '';
    }
  }

  changementProprietaire(logement: Logement) {
    this.router.navigate([`/changement-proprietaire/${logement.id}`]);
  }
}
